<template>
  <v-dialog v-model="isDialog"  persistent max-width="460">
    <v-card class="Login_Dialog" v-if="Dialog">
      <div class="login-modal">
        <v-icon style="position: absolute; right: 6%" @click="CloseModel"
          >mdi-close</v-icon
        >
        <div class="logo">
          <!-- <img src="/img/logos/iba-logo-mini.svg" alt="companyName" /> -->
          <img src="/img/bodytalk-logo.17768899.svg" alt="BodyTalk" />
        </div>
        <form @submit.prevent="submit">
          <div
            class="form-group pt-1 mb-2"
            :class="{ 'form-group--error': $v.form.Email?.$error }"
          >
            <v-text-field
              label="Email Address"
              placeholder="youremail@company.com"
              append-icon="mdi-email-outline"
              v-model="form.Email"
              :error-messages="getErrorMessage('Email')"
              ></v-text-field>
              <!-- :prepend-icon="$v.form.Email?.$error ? 'mdi-alert' : ''" -->
              
          </div>
          <div
            class="form-group pt-1 mb-0"
            :class="{ 'form-group--error': $v.form.Password?.$error }"
          >
            <v-text-field
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              label="Password"
              value="Password"
              name="input-10-2"
              v-model="form.Password"
              :error-messages="getErrorMessage('Password')"
              class="input-group--focused"
              @click:append="show1 = !show1"
              ></v-text-field>
              <!-- :error="$v.form.Password?.$error" -->
            <!-- :prepend-icon="$v.form.Password?.$error ? 'mdi-alert' : ''" -->
          </div>
          <div class="btn-forgot-pass">
            <a class="link mt-4 mb-4" @click="GoToForgetPassword"
              >Forgot password?</a
            >
          </div>

          <v-btn
            class="button mt-5"
            block
            height="50"
            color="primary"
            type="button"
            @click="submit"
            :disabled="btnloader"
          >
            <div v-if="btnloader != true">Login</div>
            <v-progress-circular
              indeterminate
              v-show="btnloader"
              color="white"
            ></v-progress-circular>
          </v-btn>
          <div class="link-register">
            <p class="">
              Don’t have an account?
              <a class="link" @click="GotoRegister"> Register Today </a>.
            </p>
          </div>
        </form>
      </div>
    </v-card>
    <v-dialog v-model="ConfirmEmailPopup" persistent max-width="500">
      <v-card class="pa-6">
        <div class="d-flex justify-end">
          <v-icon @click="ConfirmEmailPopup = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center">
          <h3 class="m-0"><b>Please confirm your email. </b></h3>
        </div>
        
        <div class="d-flex justify-center mt-5">
          <h5 class="m-0 text-center">
             Before proceeding with purchase, check your email to confirm your account.
          </h5>
        </div>
        <div class="d-flex justify-center mt-5">
          <h5 class="m-0 text-center">
           When that step is complete, a new page will open. However, to access your cart, you must then return to this page to enter your login details.
          </h5>
        </div>
        <div class="d-flex justify-center">
          <v-btn
            class="mt-5 px-12"
            height="50"
            color="primary"
            type="button"
            @click="ConfirmEmailPopup = false"
          >
            <div>Ok</div>
            
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script lang="ts">
import { required, email, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import { defineComponent } from "vue";
import Login from "@/assets/Models/Login";
import { mapGetters } from "vuex";

export default defineComponent({
  props: ["Dialog","redirectRoute"],
  mixins: [validationMixin],
  data() {
    return {
      btnloader: false,
      ConfirmEmailPopup: false,
      errorIcon: false as boolean, 
      show1: false as boolean,
      // password: "" as string,
      form: { 
        Email: "",
        Password: "",
        AccountType: 1,
      } as Login,
      submitStatus: "" as string,
    };
  },
  mounted(){
    this.form.Password = "";
    this.form.Email = "";
    if(this.$store.state.redirectToPreviousRoute) {
      this.ConfirmEmailPopup = true;
    }
  },
  validations: {
    form: {
      Password: {
        required, minLength: minLength(8),
      },
      Email: { required, email },
    },
  },
  computed: {
    isDialog(): boolean {
      return this.Dialog;
    },
    ...mapGetters(["GetUser"])
  },
  
  methods: {
    getErrorMessage(fieldName: string): string | null {
      const errorMessages: Record<string, Record<string, string>> = {
        Email: {
          required: "Email is required",
          email: "Invalid email address",
        },
        Password: {
          required: "Password is required",
          minLength: "Password must be at least 8 characters",
        },
      };
      const errorField = this.$v.form[fieldName];
      if (!errorField || !errorField.$dirty) return null;
      const errors: string[] = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    GoToForgetPassword() {
      this.$router.push("/forgotpassword");
    },
    onClickLogin() {
      this.$emit("isLogined");
      if(this.$route.query.UserId == this.GetUser.Id){
        return
      }
      const userId = this.GetUser.Id;
      this.$store.dispatch("GetAllUserNotifications", userId)
      this.$store.dispatch("GetCheckUserMembershipExpiration", userId)
            if (this.redirectRoute) {
              this.$router.push(this.redirectRoute);
              this.$emit("loginSuccessToRegisterSeminar");
            } else if(this.$store.state.redirectToPreviousRoute) {
              this.ConfirmEmailPopup = true;
              const obj = {
                UserID: this.GetUser?.Id,
                GuestID: localStorage.getItem("CartSession")?.toString()
              }
              this.$store.dispatch("SyncGuestCartToUser", obj).then(()=>{
                const cart = {
                  UserId: this.GetUser?.Id,
                  IsOriginalCart: localStorage.getItem("IsOriginalCart"),
                };
                this.$store.dispatch("GetCartItems", cart)
                this.$router.push(this.$store.state.redirectToPreviousRoute)
              })
            } else {
              if (this.$route.path !== "/") {
                this.$router.push("/");
              }
            }
      // window.location.reload();
    },
    CloseModel() {
      this.$v.form.$reset()
      this.$emit("CloseModel");
      this.form.Password = "";
      this.form.Email = "";
      this.btnloader = false;
    },
    GotoRegister() {
      this.$emit("CloseModel");
      this.$router.push("/register");
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.btnloader = true;
        this.$store
          .dispatch("Login", this.form)
          .then(() => {
            this.$v.form.$reset()
            this.onClickLogin();
            this.btnloader = false;
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: "Logged In Successfully",
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
            this.form.Password = "";
            this.form.Email = "";
          })
          .catch((res) => {
            this.btnloader = false;
            this.$swal.fire({
              position: "top-end",
              icon: "error",
              title: res.response?.data?.Message == "Email not confirmed."? "Email is not Confirmed": res.response?.data?.Message,
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
            this.form.Password = "";
            this.form.Email = "";
          });
        // do your submit logic here
        this.submitStatus = "PENDING";
      }
    },
  },
});
</script>

<style scoped>
.v-application .error {
  background-color: white !important;
  color: red;
}
.text_warnig {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: red;
}
</style>
